import { Keycap } from "@/components/keycap/Keycap";
import { StatusBadge } from "@/components/StatusBadge";
import { MarketplaceAvailabilityBadge } from "./MarketplaceAvailabilityBadge";
import { CtaLink } from "@/components/Button";
import { marketplaceCategoryLabels, type MarketplaceListing } from "@/types/content";
import "./MarketplaceListingCard.css";

/**
 * One real Marketplace catalogue entry. Always shows both the engineering
 * status (`StatusBadge`, is it built) and the acquisition availability
 * (`MarketplaceAvailabilityBadge`, can you get it) — the two are never the
 * same thing. Never a Buy/Install/Publish button; only informational
 * navigation to a real page with more detail.
 */
export function MarketplaceListingCard({ listing }: { listing: MarketplaceListing }) {
  return (
    <article className="marketplace-listing-card">
      <div className="marketplace-listing-head">
        <Keycap id={listing.keycap} size="md" />
        <div className="marketplace-listing-badges">
          <StatusBadge status={listing.status} />
          <MarketplaceAvailabilityBadge availability={listing.availability} />
        </div>
      </div>
      <p className="marketplace-listing-category">{marketplaceCategoryLabels[listing.category]}</p>
      <h3 className="marketplace-listing-name">{listing.name}</h3>
      <p className="marketplace-listing-description">{listing.description}</p>
      <dl className="marketplace-listing-meta">
        <div>
          <dt>Publisher</dt>
          <dd>
            {listing.publisher}
            {listing.firstParty ? " (first-party)" : " (third-party)"}
          </dd>
        </div>
        <div>
          <dt>Compatibility</dt>
          <dd>{listing.compatibility}</dd>
        </div>
        {listing.version ? (
          <div>
            <dt>Version</dt>
            <dd>{listing.version}</dd>
          </div>
        ) : null}
        {listing.qualification ? (
          <div>
            <dt>Qualification</dt>
            <dd>{listing.qualification}</dd>
          </div>
        ) : null}
        <div>
          <dt>Installable today</dt>
          <dd>{listing.installable ? "Yes" : "No"}</dd>
        </div>
      </dl>
      {listing.detailPath ? (
        <CtaLink to={listing.detailPath} variant="secondary" className="marketplace-listing-link">
          View details
        </CtaLink>
      ) : null}
    </article>
  );
}
